<div class="events-list-wrapper">
    <div class="events-list-header" [ngClass]="{'hide-panel' : !showEventsPanel}">
    <span class="events-list-header-label" *ngIf="showEventsPanel">
      {{'Events' | stringTranslate }}
    </span>
        <span class="events-list-header-actions" (click)="showHideEventsPanel()">
            <i [ngClass]="showEventsPanel ? 'icon__NavigationLeft1' : 'icon__NavigationRight'">
            </i>
    </span>
  </div>
  <div class="events-list-container" [ngClass]="{'hide-list-panel' : !showEventsPanel, 'hide-group-panel' : !showEventsGroup}" #event_list_container>
    <div *ngIf="showEventsGroup">
      <p-accordion
              *ngFor="let eventType of eventTypes"
              expandIcon="icon__expand" collapseIcon="icon__collapse">
        <p-accordionTab
                [ngClass]="{'event-group-active': selectedEvent?.group?.display === eventType.key, 'hide-event-group': (!showEventsGroup && showEventsPanel)}"
                [selected]="selectedEvent?.group?.display === eventType.key || !showEventsGroup || !showEventsPanel || expandAll">
          <p-header class="p-accordion-header">
          <span class="event-icon">
            <i [ngClass]="eventType?.val[0]?.group?.iconName"></i>
          </span>
                        <span class="event-category-label">{{eventType.key | stringTranslate}}</span>
                    </p-header>
                    <ng-container
                            [ngTemplateOutlet]="eventListContent"
                            [ngTemplateOutletContext]="{events:eventType.val}">
                    </ng-container>
                </p-accordionTab>
            </p-accordion>
        </div>
        <div *ngIf="!showEventsGroup">
            <ng-container
                    [ngTemplateOutlet]="eventListContent"
                    [ngTemplateOutletContext]="{events:eventCategories}">
            </ng-container>
        </div>
    </div>
    <div class="event-add-action-container" *ngIf="isEditable && addEventAvailable">
        <gen-button
                *ngIf="showEventsPanel"
                [type]="'secondary'"
                [iconClass]="'icon__Plus2'"
                (click)="createNewEvent()"
                [text]="'NEW_EVENT'"></gen-button>
        <div class="add-button"
                *ngIf="!showEventsPanel"
                (click)="createNewEvent()">
            <i class="icon__Plus1"></i>
        </div>
    </div>
</div>
<ng-template #eventListContent let-events='events'>
    <dls-list-view class="pt-bordered">
        <dls-list-item class="event-information pt-separator" *ngFor="let event of events"
                       (click)="suggestionWasClicked(event)"
                       [selected]="selectedEvent?.id === event.id"
                       [ngClass]="{'active': selectedEvent?.id === event.id, 'event-information-minimal': !showEventsPanel}">
          <span class="event-icon" *ngIf="!showEventsPanel"
                genTooltip tooltipPosition="RIGHT"
                tooltipText="{{event.date |date: 'dd MMM y'}} - {{event.category.display | stringTranslate}}" tooltipShow="true">
            <i [ngClass]="event?.event_icon"></i>
            <i class="event-included-in-timeline"
               *ngIf="!event.approved"
               [ngClass]="'icon__QuestionmarkCircle'"></i>
           <i class="event-is-selected"
              *ngIf="event.selected &&  config.maxEventSelection === 1"
              [ngClass]="'icon__check'">
           </i>
          </span>
            <span class="event-actions-wrapper left-align" *ngIf="config.showEventSelection">
                <p-checkbox *ngIf="selectedEvent && config.maxEventSelection > 1"
                            value="Select event"
                            label=""
                            binary="true"
                            [disabled]="isEventSelectionDisabled(event.selected)"
                            (click)="$event.stopPropagation();"
                            (onChange)="selectEvent(event,$event);"
                            [ngModel]="event.selected">
                </p-checkbox>
                <i class="event-is-selected"
                   *ngIf="event.selected &&  config.maxEventSelection === 1"
                   [ngClass]="'icon__check'">
               </i>
          </span>
            <span class="event-type-container">
            {{event.date |date: 'dd MMM y':'undefined' :locale }} - {{event.category.display | stringTranslate}}
            </span>
            <section class="last-column right-align-items">
                <dls-icon class="pt-icon icon__QuestionmarkCircle question-mark-color" *ngIf="!event.approved"></dls-icon>
                <dls-icon class="pt-icon event-delete-icon pancancer__icon__CrossCircle1"
                          *ngIf="isEditable && deleteEventAvailable  && (!event.isExternal || event.isExternal === false)"
                          (click)="deleteEvent(event); $event.stopPropagation()"></dls-icon>
            </section>
        </dls-list-item>
    </dls-list-view>
</ng-template>
